
import React, { useState, useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';
import AuthLayout from '@/components/auth/AuthLayout';
import RegisterForm from '@/components/auth/RegisterForm';
import { useUser } from '@/contexts/UserContext';
import { Alert, AlertDescription } from '@/components/ui/alert';

export default function Register() {
  const { isAuthenticated, isLoading } = useUser();
  const [registrationError, setRegistrationError] = useState<string | null>(null);

  // Reset any errors when component mounts or remounts
  useEffect(() => {
    setRegistrationError(null);
  }, []);

  // Show loading spinner while auth state is being determined
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect authenticated users to home
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <AuthLayout 
      title="Create Account" 
      description="Sign up to start planning meals for your family"
    >
      {registrationError && (
        <Alert variant="destructive" className="mb-4">
          <AlertDescription>{registrationError}</AlertDescription>
        </Alert>
      )}
      <RegisterForm />
    </AuthLayout>
  );
}
